<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <ProductsForm @submit-requested="submitRequested"></ProductsForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import ProductsForm from './ProductsForm.vue'

  export default {
  components: { ProductsForm },
  methods: {
    ...mapActions('products', ['postProduct']),
    submitRequested (input) {
      this.postProduct(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 